module.exports = __webpack_public_path__ + "static/media/MERN-Logo-4-pack.d31af108.jpg";